export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center bg-gradient-to-br from-background-100 via-background-50 to-primary-50/50 overflow-hidden"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>妖精视频 · 桃花视频 · 苹果视频 · 榴莲视频</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 leading-tight">
              青青草视频
              <span className="block text-primary-600 mt-1">影视大全与热门视频合集平台</span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-foreground-600 font-medium">
              海量精选 · 每日更新 · 高清畅享
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              青青草视频汇聚妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频、菠萝视频、红杏视频等多家特色平台资源，
              打造一站式影视大全与热门视频合集。每日精选更新，涵盖多元主题分类，
              为用户提供便捷高效的视频内容发现与浏览体验。无论您偏好哪种风格，
              都能在这里找到心仪的影视内容与热门视频合集。
            </p>

            <div className="flex items-center gap-6 md:gap-10 mt-7 justify-center lg:justify-start flex-wrap">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">50+</p>
                <p className="text-xs text-foreground-500 mt-0.5">覆盖视频平台</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">10W+</p>
                <p className="text-xs text-foreground-500 mt-0.5">精选视频资源</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">99%</p>
                <p className="text-xs text-foreground-500 mt-0.5">高清资源占比</p>
              </div>
            </div>

            <div className="flex items-center gap-4 mt-8 justify-center lg:justify-start flex-wrap">
              <button
                onClick={() => scrollTo('#media')}
                className="px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
              >
                立即浏览精选
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="px-7 py-3 bg-background-50 text-foreground-800 rounded-full text-sm font-semibold border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看视频索引
                <i className="ri-grid-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20digital%20streaming%20platform%20interface%20with%20warm%20ambient%20lighting%2C%20cinematic%20atmosphere%2C%20modern%20minimalist%20design%2C%20soft%20coral%20and%20amber%20tones%2C%20elegant%20composition%2C%20editorial%20quality%2C%20high%20detail%2C%20warm%20gradient%20overlay&width=1200&height=900&seq=hero-main-2026&orientation=landscape"
                  alt="青青草视频 - 影视大全与热门视频合集平台主视觉"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-accent-400/20 rounded-2xl -z-10"></div>
              <div className="absolute -top-3 -left-3 w-16 h-16 bg-primary-400/20 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}